export const shareBikeTheme = {
  navBackground: "#3f51b5",
  navText: "#ffffff",
  navLogoutText: "#3f51b5",
};
export const shematicTheme = {
  navBackground: "#000000",
  navText: "#ffffff",
  navLogoutText: "#000000",
};
export const mobyTheme = {
  navBackground: "#000000",
  navText: "#c8ff00",
  navLogoutText: "#000000",
};
export const bigIssueTheme = {
  navBackground: "#ed3159",
  navText: "#000000",
  navLogoutText: "#ed3159",
};

export const farteTheme = {
  navBackground: "#FFD520",
  navText: "#000000",
  navLogoutText: "#FFD520",
};

export const sigoTheme = {
  navBackground: "#00cc77",
  navText: "#000000",
  navLogoutText: "#00cc77",
};

export const sefaTheme = {
  navBackground: "#31227e",
  navText: "#ffffff",
  navLogoutText: "#31227e",
};

export const weelzTheme = {
  navBackground: "#54EFED",
  navText: "#000000",
  navLogoutText: "#54EFED",
};

export const gjovikTheme = {
  navBackground: "#007AC1",
  navText: "#ffffff",
  navLogoutText: "#007AC1",
};
